import React from 'react';
import { Spin } from 'antd';
// import iconLoading from '@/assets/images/point/tm_loading.gif';
import { getThemeImgByKey } from '@/utils/utils';
import iconLoading from '@/assets/images/point/post_loading.gif';
import styles from './index.less';

const BaseSpin = props => {
  const { children, ...otherProps } = props;
  return (
    <Spin
      indicator={(
        <div className={styles.bgLoading}>
          <img src={getThemeImgByKey('genericLoader') || iconLoading} alt="" />
        </div>
      )}
      {...otherProps}
    >
      {children}
    </Spin>
  );
};

export default BaseSpin;
